/* eslint-disable */
export default {
  createLog: '建立記錄',
  creating: '建立中',
  save: '儲存',
  saving: '儲存中',
  saved: '已儲存',
  view: '檢視',
  creatingFailed: '建立失敗。',
  savingFailed: '儲存失敗。',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
